import getEnvironment from "../../getEnvironment";

export const getHeaders = (
  authToken: string,
  isToUseAuthZero: boolean,
  token?: string
) => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
    "Cache-Control": "private, max-age=0, no-cache, no-store",
  };
  if (isToUseAuthZero) {
    headers = { ...headers, Authorization: `Bearer ${authToken}` };
  } else {
    if (getEnvironment() === "localhost") {
      if (!process.env.TOKEN) {
        console.log("TOKEN variable not set.");
      }

      headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
    } else {
      if (token) {
        headers = { ...headers, Authorization: `Bearer ${token}` };
      }
    }
  }

  return headers;
};
